import ReviewsCreditCards from './ReviewsCreditCards';
import ReviewsList from './ReviewsList';
import ReviewsOrderProcessing from './ReviewsOrderProcessing';
import ReviewsExample from './ReviewsExample';
import ReviewsInvitation from './ReviewsInvitation';

export { ReviewsCreditCards, ReviewsList, ReviewsOrderProcessing, ReviewsInvitation, ReviewsExample };
